import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Benefit = {
  benefit_id?: number; // 혜택 idx
  benefit_name?: string; // 혜택명
  benefit?: { [key: string]: Record<string, any> }; // 혜택
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Benefit
   * --
   */
  getBenefits: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_BENEFIT, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Benefit
   * --
   */
  getBenefit: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_BENEFIT, { benefit_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Benefit
   * --
   */
  createBenefit: async (body: Benefit) => {
    try {
      const res = await $http.post(APIConstant.CREATE_BENEFIT, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Benefit
   * --
   */
  updateBenefit: async (body: Benefit) => {
    try {
      const { benefit_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_BENEFIT, {
        benefit_id: benefit_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Benefit
   * --
   */
  deleteBenefit: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_BENEFIT, {
        benefit_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
